/**
 * Frasi simpatiche di caricamento - Traduzione italiana
 * Fonte originale: https://gist.github.com/meain/6440b706a97d2dd71574769517e7ed32
 */

export const loadingMessages = [
  "Reticolando le spline...",
  "Generando dialoghi spiritosi...",
  "Scambiando tempo e spazio...",
  "Ruotando violentemente attorno all'asse y...",
  "Tokenizzando la vita reale...",
  "Piegando il cucchiaio...",
  "Filtrando il morale...",
  "Non pensare agli ippopotami viola...",
  "Ci serve un nuovo fusibile...",
  "Buona giornata.",
  "Aggiornando Windows, il PC si riavvierà più volte. Rilassati.",
  "640K dovrebbero bastare per chiunque",
  "Gli architetti stanno ancora progettando",
  "I bit si stanno riproducendo",
  "Stiamo costruendo gli edifici il più velocemente possibile",
  "Preferisci pollo, bistecca o tofu?",
  "(Non prestare attenzione all'uomo dietro la tenda)",
  "...e goditi la musica dell'ascensore...",
  "Attendi mentre i piccoli elfi disegnano la tua mappa",
  "Non preoccuparti - alcuni bit hanno provato a scappare, ma li abbiamo presi",
  "Vuoi le patatine con quello?",
  "Controllando la costante gravitazionale nella tua zona...",
  "Vai avanti -- trattieni il respiro!",
  "...almeno non sei in attesa...",
  "Canticchia qualcosa ad alta voce mentre gli altri ti fissano",
  "Non sei più in Kansas",
  "Il server è alimentato da un limone e due elettrodi.",
  "Attendi mentre un grande fornitore di software a Seattle conquista il mondo",
  "Stiamo testando la tua pazienza",
  "Come se avessi altre scelte",
  "Segui il coniglio bianco",
  "Perché non ordini un panino?",
  "Mentre il satellite si posiziona",
  "Mantieni la calma e fai npm install",
  "I bit fluiscono lentamente oggi",
  "Scava sulla 'X' per il tesoro sepolto... ARRR!",
  "È comunque più veloce di quanto potresti disegnarlo tu",
  "L'ultima volta che ho provato la scimmia non è sopravvissuta. Speriamo funzioni meglio stavolta.",
  "Avrei dovuto bere un V8 stamattina.",
  "La mia altra schermata di caricamento è molto più veloce.",
  "Test su Timmy... Ci servirà un altro Timmy.",
  "Riconfobulando l'energymotron...",
  "(Inserisci moneta)",
  "Ci siamo quasi?",
  "Hai perso peso?",
  "Conta fino a 10",
  "Perché così serio?",
  "Non sei tu. Sono io.",
  "Contando all'indietro dall'Infinito",
  "Niente panico...",
  "Ingrandendo i prototipi",
  "Non correre! Siamo tuoi amici!",
  "Vieni qui spesso?",
  "Attenzione: Non darti fuoco.",
  "Ti stiamo preparando un biscotto.",
  "Creando campo di inversione del loop temporale",
  "Girando la ruota della fortuna...",
  "Caricando il coniglio incantato...",
  "Calcolando le probabilità di successo",
  "Mi dispiace Dave, non posso farlo.",
  "Cercando il resto esatto",
  "Tutti i tuoi browser appartengono a noi",
  "Tutto ciò di cui ho veramente bisogno è un kilobit.",
  "Ho la sensazione che dovrei caricare qualcosa...",
  "Come si chiamano 8 Hobbit? Un Hobbyte.",
  "Avresti dovuto usare un linguaggio compilato...",
  "È Windows questo?",
  "Regolando il condensatore di flusso...",
  "Attendi che il bradipo inizi a muoversi.",
  "Non rompere ancora lo schermo!",
  "Giuro che è quasi finito.",
  "Prendiamoci un minuto di mindfulness...",
  "Gli unicorni sono alla fine di questa strada, promesso.",
  "Ascoltando il suono di una mano che applaude...",
  "Tenendo tutti gli 1 e rimuovendo tutti gli 0...",
  "Mettendo la glassa sulla torta. La torta non è una bugia...",
  "Togliendo le ragnatele...",
  "Assicurandoci che tutte le i abbiano i puntini...",
  "Ci servono più cristalli di dilitio",
  "Dove sono finiti tutti gli internet",
  "Collegando il serbatoio di neurotossine...",
  "Esaudendo desideri...",
  "Il tempo vola quando ti diverti.",
  "Prenditi un caffè e torna tra dieci minuti..",
  "Facendo girare il criceto…",
  "99 bottiglie di birra sul muro..",
  "Resta un po' e ascolta..",
  "Attento a non calpestare la git-gui",
  "Non passerai! ancora..",
  "Caricalo e verranno",
  "Convincendo l'IA a non diventare malvagia..",
  "Non c'è il cucchiaio. Perché non abbiamo finito di caricarlo",
  "Il tuo pollice sinistro punta a destra e il tuo pollice destro punta a sinistra.",
  "Come sei arrivato qui?",
  "Aspetta, senti odore di bruciato?",
  "Calcolando il segreto della vita, dell'universo e di tutto quanto.",
  "Quando niente va per il verso giusto, vai a sinistra!!...",
  "Amo il mio lavoro solo quando sono in vacanza...",
  "Non sono pigro, sono solo rilassato!!",
  "Non rubare mai. Al governo non piace la concorrenza....",
  "Perché si chiamano appartamenti se sono tutti attaccati?",
  "La vita è breve – Parla veloce!!!!",
  "Ottimismo – è mancanza di informazioni.....",
  "Risparmia acqua e fai la doccia insieme",
  "Ogni volta che trovo la chiave del successo, qualcuno cambia la serratura.",
  "A volte penso che la guerra sia il modo di Dio di insegnarci la geografia.",
  "Ho un problema per la tua soluzione…..",
  "Dove c'è un testamento, c'è un parente.",
  "Utente: la parola che i professionisti informatici usano quando intendono !!idiota!!",
  "Gli adulti sono solo bambini con i soldi.",
  "Penso di essere, quindi, sono. Penso.",
  "Un bacio è come una lotta, con le bocche.",
  "Non paghi le tasse—le prendono.",
  "Caffè, Cioccolato, Uomini. Più ricchi è meglio!",
  "Sono libero da tutti i pregiudizi. Odio tutti allo stesso modo.",
  "git succede",
  "Che i fork siano con te",
  "Un commit al giorno toglie la folla di torno",
  "Questo non è uno scherzo, è un commit.",
  "Costruendo piloni aggiuntivi...",
  "Legando alcune tartarughe marine...",
  "Localizzando Jebediah Kerman...",
  "Non siamo responsabili per schermi rotti a causa dell'attesa.",
  "Ciao IT, hai provato a spegnerlo e riaccenderlo?",
  "Se digiti Google in Google puoi rompere internet",
  "Beh, questo è imbarazzante.",
  "Qual è la velocità aerodinamica di una rondine senza carico?",
  "Ciao, IT... Hai provato a forzare un riavvio inaspettato?",
  "Ci buttano via come la marmellata di ieri.",
  "Sono abbastanza regolari, le botte, sì. Direi che siamo su base bisettimanale.",
  "Gli Anziani di Internet non lo sopporterebbero mai.",
  "Lo spazio è polvere mentale invisibile, e le stelle sono solo desideri.",
  "Non sapevo che la vernice si asciugasse così in fretta.",
  "Tutto suona uguale",
  "Vado a portare fuori il cane",
  "Non ho scelto la vita da ingegnere. La vita da ingegnere ha scelto me.",
  "Dividendo per zero...",
  "Genera più Overlord!",
  "Se non torno in cinque minuti, aspetta ancora.",
  "Alcuni giorni, non riesci proprio a liberarti di un bug!",
  "Ci servirà una barca più grande.",
  "Chuck Norris non fa mai git push. Il repo fa pull prima.",
  "Gli sviluppatori web lo fanno con <style>",
  "Devo fare git pull --my-life-together",
  "Gli sviluppatori Java non RIP. Vengono solo raccolti dal Garbage Collector.",
  "Crackerando crittografia di grado militare...",
  "Simulando il commesso viaggiatore...",
  "Dimostrando P=NP...",
  "Intrecciando superstringhe...",
  "Giocherellando con i pollici...",
  "Cercando espediente narrativo...",
  "Provando a ordinare in O(n)...",
  "Ridendo delle tue foto-voglio dire, caricando...",
  "Inviando dati alla NS-voglio dire, ai nostri server.",
  "Cercando il senso dell'umorismo, attendi.",
  "Attendi mentre lo stagista riempie il suo caffè.",
  "Un messaggio di errore diverso? Finalmente, qualche progresso!",
  "Aspetta mentre mettiamo insieme il nostro git...scusa",
  "Attendi mentre riscaldiamo il nostro caffè",
  "Attendi mentre convertiamo questo bug in una funzionalità...",
  "Attendi mentre il nostro stagista esce da vim...",
  "L'inverno sta arrivando...",
  "Installando dipendenze",
  "Passando all'ultimo framework JS...",
  "Distratto da gif di gatti",
  "Cercando qualcuno che mi tenga la birra",
  "Torno subito, sto lavorando al mio progetto personale",
  "@todo Inserire messaggio di caricamento spiritoso",
  "Speriamo ne valga la pena",
  "Aw, snap! No..",
  "Ordinando 1 e 0...",
  "Aggiornando dipendenze...",
  "Qualunque cosa tu faccia, non guardare dietro di te...",
  "Attendi... Consultando il manuale...",
  "È buio. Probabilmente verrai mangiato da un grue.",
  "Caricando messaggio divertente...",
  "Sono le 22:00. Sai dove sono i tuoi figli?",
  "Aspettando che Daenerys dica tutti i suoi titoli...",
  "Sentiti libero di girare sulla tua sedia",
  "Che cosa?",
  "format C: ...",
  "Dimentica di aver visto quella password che ho appena digitato nell'IM...",
  "Cosa c'è là sotto?",
  "Il tuo computer ha un virus, si chiama Windows!",
  "Vai avanti, trattieni il respiro e fai un plank ironman fino al caricamento completo",
  "Annoiato dallo spinner di caricamento lento, compra più RAM!",
  "Aiuto, sono intrappolato in un loader!",
  "Qual è la differenza tra un ippopotamo e uno zippo? Uno è molto pesante, l'altro è un po' più leggero",
  "Attendi, mentre purghiamo i Decepticon per te. Sì, puoi ringraziarci dopo!",
  "Chuck Norris una volta ha urinato nel serbatoio di un camion per scherzo....quel camion ora è conosciuto come Optimus Prime.",
  "Chuck Norris non porta l'orologio. È LUI che decide che ora è.",
  "Minando alcuni bitcoin...",
  "Scaricando più RAM..",
  "Aggiornando a Windows Vista...",
  "Eliminando la cartella System32",
  "Nascondendo tutti i ; nel tuo codice",
  "Alt-F4 velocizza le cose.",
  "Inizializzando l'inizializzatore...",
  "Quando è stata l'ultima volta che hai spolverato qui?",
  "Ottimizzando l'ottimizzatore...",
  "Ultima chiamata per il bus dati! Tutti a bordo!",
  "Eseguendo rilevamento adesivi swag...",
  "Non far mai sapere a un computer che hai fretta.",
  "Un computer farà quello che gli dici di fare, ma potrebbe essere molto diverso da quello che avevi in mente.",
  "Alcune cose l'uomo non era destinato a sapere. Per tutto il resto, c'è Google.",
  "Unix è user-friendly. È solo molto selettivo su chi sono i suoi amici.",
  "Spalando carbone nel server",
  "Spingendo pixel...",
  "Che ne dici di questo tempo, eh?",
  "Costruendo un muro...",
  "Tutto in questo universo è o una patata o non una patata",
  "La gravità del tuo problema è sempre inferiore a quanto ti aspettavi.",
  "Aggiornando l'Aggiornatore...",
  "Scaricando lo Scaricatore...",
  "Debuggando il Debugger...",
  "Leggendo Termini e Condizioni per te.",
  "Cookie digeriti vengono cotti di nuovo.",
  "Lunga vita e prosperità.",
  "Non c'è il livello mucca, ma c'è quello della capra!",
  "Eliminando tutto il tuo porno nascosto...",
  "Correndo con le forbici...",
  "Decisamente non un virus...",
  "Puoi chiamarmi Steve.",
  "Sembri una brava persona...",
  "Caffè a casa mia, domani alle 10. - non fare tardi!",
  "Lavoro, lavoro...",
  "Pazienza! Questo è difficile, sai...",
  "Scoprendo nuovi modi per farti aspettare...",
  "Il tuo tempo è molto importante per noi. Attendi mentre ti ignoriamo...",
  "Il tempo vola come una freccia; la frutta vola come una banana",
  "Due uomini sono entrati in un bar; il terzo si è abbassato...",
  "Allora... Hai già visto le mie foto delle vacanze?",
  "Scusa siamo occupati a prenderli tutti, abbiamo quasi finito",
  "TODO: Inserire musica d'ascensore",
  "Ancora più veloce di Windows update",
  "Hack Composer: Aspettare che i requisiti vengano recuperati è meno frustrante se aggiungi -vvv al tuo comando.",
  "Attendi mentre i minion fanno il loro lavoro",
  "Prendendo minion extra",
  "Facendo il lavoro pesante",
  "Stiamo lavorando molto duramente.... Davvero",
  "Svegliando i minion",
  "Sei il numero 2843684714 nella coda",
  "Attendi mentre serviamo altri clienti...",
  "Il nostro piano premium è più veloce",
  "Nutrendo unicorni...",
  "Rompendo la barriera del subspazio",
  "Creando una reazione anti-tempo",
  "Convergendo impulsi tachionici",
  "Bypassando il controllo dell'integratore materia-antimateria",
  "Regolando l'assemblaggio del convertitore di cristalli di dilitio",
  "Invertendo la polarità degli scudi",
  "Interrompendo i campi warp con un'esplosione di gravitoni inversi",
  "Su, Su, Giù, Giù, Sinistra, Destra, Sinistra, Destra, B, A.",
  "Ti piace la mia animazione di caricamento? L'ho fatta io",
  "Whoah, guarda come va!",
  "No, sono sveglio. Stavo solo riposando gli occhi.",
  "Uno mississippi, due mississippi...",
  "Niente panico... AHHHHH!",
  "Assicurandoci che gli Gnomi siano ancora bassi.",
  "Cuocendo il gelato...",
  "Scaldo internet..",
];

/**
 * Ottiene un messaggio di caricamento casuale
 */
export const getRandomLoadingMessage = (): string => {
  return loadingMessages[Math.floor(Math.random() * loadingMessages.length)];
};
